// extracted by mini-css-extract-plugin
export default {"zeroData":"zeroData_zeroData__jKhWG"};